var render = function render(){var _vm=this,_c=_vm._self._c;return _c('photo-validation-error-modal',{attrs:{"name":"photo-too-large-file-size-modal","title":_vm.$t('photoValidation.title.maxAllowableSize'),"error-message":_vm.$t('photoValidation.text.maxAllowableSize')}})
}
var staticRenderFns = []

export { render, staticRenderFns }